module.exports = __webpack_public_path__ + "img/6.91943fe1.jpg";